import {Container} from "react-bootstrap";

function $1(props) {
    return (
        <Container>
            <div className="d-flex center">
                <div className="text-center">
                    <h1 className="display-1 fw-bold">404</h1>
                    <p className="fs-3"><span className="text-danger">Opps!</span> Page not found.</p>
                    <p className="lead">
                        The page you’re looking for doesn’t exist.
                    </p>
                </div>
            </div>
        </Container>
    );
}

export default $1;